import { Routes } from '@angular/router';

import { redirectSuperAdminGuard, superAdminOnlyGuard } from './guards/super-admin.guard';

const routes: Routes = [
  {
    path: 'tenants',
    canActivate: [superAdminOnlyGuard],
    loadComponent: () => import('./pages/tenants-page/tenants-page.component').then((c) => c.TenantsPageComponent),
  },
  {
    path: '',
    canActivate: [redirectSuperAdminGuard],
    loadComponent: () => import('./pages/main-page/main-page.component').then((c) => c.MainPageComponent),
    children: [
      {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full',
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./pages/projects-page/projects-page.component').then((c) => c.ProjectsPageComponent),
      },
      {
        path: 'archived-projects',
        loadComponent: () =>
          import('./pages/archived-projects-page/archived-projects-page.component').then(
            (c) => c.ArchivedProjectsPageComponent,
          ),
      },
    ],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard-page/dashboard-page.component').then((c) => c.DashboardPageComponent),
    children: [{ path: '**', redirectTo: 'projects' }],
  },
  {
    path: 'dashboard/:id',
    loadComponent: () =>
      import('./pages/dashboard-page/dashboard-page.component').then((c) => c.DashboardPageComponent),
    children: [
      {
        path: 'gallery',
        loadComponent: () => import('./pages/gallery-page/gallery-page.component').then((c) => c.GalleryPageComponent),
      },
      {
        path: 'reports',
        loadComponent: () => import('./pages/reports-page/reports-page.component').then((c) => c.ReportsPageComponent),
      },
      {
        path: 'supervisely',
        loadComponent: () =>
          import('./pages/supervisely-page/supervisely-page.component').then((c) => c.SuperviselyPageComponent),
      },
      {
        path: 'digital-twin',
        loadComponent: () =>
          import('./pages/digital-twin-page/digital-twin-page.component').then((c) => c.DigitalTwinPageComponent),
      },
      {
        path: 'file-system',
        loadComponent: () =>
          import('./pages/file-system-page/file-system-page.component').then((c) => c.FileSystemPageComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings-page/settings-page.component').then((c) => c.SettingsPageComponent),
      },
      {
        path: 'analyze-with-ai',
        loadComponent: () =>
          import('./pages/analyze-with-ai-page/analyze-with-ai-page.component').then(
            (c) => c.AnalyzeWithAIPageComponent,
          ),
      },
      { path: '**', redirectTo: 'analyze-with-ai' },
    ],
  },
];

export { routes };
